<div class="wrapper has-padding">

  <h2 class="bofa--heading is-4">Security Questions</h2>

  <form [formGroup]="securityGroup" (ngSubmit)="onSubmit()">
    <mat-form-field class="flex-width width-400">
      <mat-label>Username</mat-label>
      <input matInput value="{{ username }}" disabled>
    </mat-form-field>

    <p class="bofa--heading is-6 group">Select and answer five challenge questions</p>
    <p class="font-13">If you forget your password, you will be asked to provide the answers to all five
      challenge questions<br /> before you are able to reset your password.</p>

    <div class="bofa--alert has-background cool-gray-5 has-padding is-stacked max-width-650">
      <ul class="has-no-padding has-no-margin font-13 list-type-none">
        <li><span class="padding-10"> <img aria-hidden="true" alt="information" class="img-size"
              src="assets/bofa_icon_info.svg"></span>Different questions. Different answers</li>
        <li class="pading-left-40">Note: You cannot select the same question twice or provide the same answer for
          different questions</li>
      </ul>
    </div>

    <mat-form-field class="flex-width width-350">
      <mat-label>Question 1</mat-label>
      <input matInput value="{{ questionOne }}" disabled>
    </mat-form-field>

    <mat-form-field class="question-space secure-questions zoom-questions-width">
      <mat-label id="q1-label">Answer to question 1</mat-label>
      <input matInput type="password" formControlName="answer1" (focus)="clearError()" placeholder="Answer 1" required
        autocomplete="off" aria-labelledby="q1-label" aria-required="true">
      <mat-error *ngIf="answer1.hasError('required')">Please enter answer 1</mat-error>
    </mat-form-field>

    <mat-form-field class="flex-width width-350">
      <mat-label>Question 2</mat-label>
      <input matInput value="{{ questionTwo }}" disabled>
    </mat-form-field>

    <mat-form-field class="question-space secure-questions zoom-questions-width">
      <mat-label id="q2-label">Answer to question 2</mat-label>
      <input matInput type="password" formControlName="answer2" (focus)="clearError()" placeholder="Answer 2" required
        autocomplete="off" aria-labelledby="q2-label" aria-required="true">
      <mat-error *ngIf="answer2.hasError('required')">Please enter answer 2</mat-error>
    </mat-form-field>

    <mat-form-field class="flex-width width-350">
      <mat-label>Question 3</mat-label>
      <input matInput value="{{ questionThree }}" disabled>
    </mat-form-field>

    <mat-form-field class="question-space secure-questions zoom-questions-width">
      <mat-label id="q3-label">Answer to question 3</mat-label>
      <input matInput type="password" formControlName="answer3" (focus)="clearError()" placeholder="Answer 3" required
        autocomplete="off" aria-labelledby="q3-label" aria-required="true">
      <mat-error *ngIf="answer3.hasError('required')">Please enter answer 3</mat-error>
    </mat-form-field>

    <mat-form-field class="flex-width width-350">
      <mat-label>Question 4</mat-label>
      <input matInput value="{{ questionFour }}" disabled>
    </mat-form-field>

    <mat-form-field class="question-space secure-questions zoom-questions-width">
      <mat-label id="q4-label">Answer to question 4</mat-label>
      <input matInput type="password" formControlName="answer4" (focus)="clearError()" placeholder="Answer 4" required
        autocomplete="off" aria-labelledby="q4-label" aria-required="true">
      <mat-error *ngIf="answer4.hasError('required')">Please enter answer 4</mat-error>
    </mat-form-field>

    <mat-form-field class="flex-width width-350">
      <mat-label>Question 5</mat-label>
      <input matInput value="{{ questionFive }}" disabled>
    </mat-form-field>

    <mat-form-field class="question-space secure-questions zoom-questions-width">
      <mat-label id="q5-label">Answer to question 5</mat-label>
      <input matInput type="password" formControlName="answer5" (focus)="clearError()" placeholder="Answer 5" required
        autocomplete="off" aria-labelledby="q5-label" aria-required="true">
      <mat-error *ngIf="answer5.hasError('required')">Please enter answer 5</mat-error>
    </mat-form-field>

    <div class="bofa--action_bar is-taller">
      <button (submit)="onSubmit()" [disabled]="!securityGroup.valid" class="bofa--button primary large">Reset my
        password</button>
    </div>
  </form>
  <p class="is-taller item"><a routerLink="/login" class="bofa--button reverse">&larr; Back</a></p>
</div>
